<template>
    <div class="EnrollDetail_container">
        <template v-if="!loadMore">
            <div class="load_more" v-if="!types.length && (!isCreateEnroll || enrollEnd)">
                <img src="https://file.dazhongyundong.com/static/no_data/no_enrolled_data.png">
            </div>
            <div class="enroll_info" v-else>
                <div class="enroll_title">报名详情</div>
                <div class="enroll_time" v-if="endTime">
                    <YD-image src="icon/icon_提示_绿色"></YD-image>
                    <span v-if="!enrollSuccess">报名截止时间: {{endTime | dateFormat('yyyy年MM月dd日HH:mm')}}</span>
                    <span v-else>报名已完成</span>
                </div>
                <ul v-if="types.length">
                    <li v-for="(item, index) in types" :key="index">
                        <div class="info">
                            <div class="num">
                                <p>{{['运动员', '队伍', '组合'][item.TeamType - 1]}}</p>
                                <p :style="{'color': ['#F79611', '#00C2DC', '#92A8FF'][item.TeamType - 1]}">{{item.TeamsCount + (item.OfflineTeamsCount || 0)}}</p>
                            </div>
                            <div class="enroll_detail">
                                <div class="enroll_title" v-if="item.TeamType == 1">个人项目已报名{{item.TeamsCount + (item.OfflineTeamsCount || 0)}}名运动员</div>
                                <div class="enroll_title" v-else-if="item.TeamType == 2">团体项目已报名{{item.TeamsCount + (item.OfflineTeamsCount || 0)}}支队伍</div>
                                <div class="enroll_title" v-else>双人项目已报名{{item.TeamsCount + (item.OfflineTeamsCount || 0)}}对组合</div>
                                <div class="enroll_group" :class="openIndexs.includes(index) ? 'open' : 'close'">
                                    <p>{{item.TeamsGroups ? item.TeamsGroups.join('、') : ""}}</p>
                                </div>
                            </div>
                            <YD-image :src="openIndexs.includes(index) ? 'icon/icon_收起_灰色' : 'icon/icon_展开_灰色'" @click.native="open(index)"></YD-image>
                        </div>
                        <div class="group_detail" v-show="openIndexs.includes(index)">
                            <template v-for="(groupItem, groupIndex) in item.GroupStatitics">
                                <div class="group_title" :key="'a' + groupIndex">
                                    <span>{{groupItem.GroupName}}共<i>{{groupItem.GroupTeamCount}}</i>{{['人', '队', '对'][item.TeamType - 1]}}</span>
                                </div>
                                <ol :key="'b' + groupIndex">
                                    <li v-for="(memberItem, memberIndex) in groupItem.GroupMembers" :key="memberIndex">
                                        <div class="member_info">
                                            <p>{{memberItem.DptName}}</p>
                                            <p>代表机构：{{memberItem.CompanyName || '无'}}</p>
                                        </div>
                                        <div class="member_num" v-if="[1,3].includes(item.TeamType)">{{memberItem.TeamCount + (['人', '队', '对'][item.TeamType - 1])}}</div>
                                        <div class="member_num" v-else></div>
                                    </li>
                                </ol>
                            </template>
                            <template v-if="item.OfflineTeamsCount > 0">
                                <div class="group_title">
                                    <span>线下报名共<i>{{item.OfflineTeamsCount}}</i>{{['人', '队', '对'][item.TeamType - 1]}}</span>
                                </div>
                                <ol>
                                    <li>
                                        <div class="member_info"><p>线下报名</p></div>
                                        <div class="member_num">{{item.OfflineTeamsCount + (['人', '队', '对'][item.TeamType - 1])}}</div>
                                    </li>
                                </ol>
                            </template>
                        </div>
                    </li>
                </ul>
                <div class="load_more" v-else>
                    <img src="https://file.dazhongyundong.com/static/no_data/no_body_enrolled.png">
                </div>
            </div>
        </template>
        <template v-else>
            <div class="load_more">{{loadMore}}</div>
        </template>
    </div>
</template>
<script>
export default {
    props:{
        subLeagueId:{
            type: Number,
            default: 0
        }
    },
    data(){
        return {
            isCreateEnroll: false,
            endTime: "",
            enrollSuccess: false,
            types: [],
            openIndexs: [],
            list: [],
            loadMore: "加载中..."
        }
    },
    created(){
        this.$api.GetLeagueEnrollDetailStatistics({
            LeagueId: this.subLeagueId
        }).then(data=>{
            this.loadMore = "";
            if(data.Code == 0){
                this.isCreateEnroll = data.IsCreateEnroll;
                this.endTime = data.EnrollEndTime;
                this.enrollSuccess = data.IsEnrollComplete;
                this.types = data.TeamTypeStatitics || [];
            }
        }).catch(()=>{
            this.loadMore = "";
        })
    },
    computed:{
        enrollEnd(){
            return this.endTime && new Date(this.endTime).getTime() < new Date().getTime(); 
        }
    },
    methods:{
        open(index){
            var arr = this.openIndexs,
                i = arr.indexOf(index);
            if(i > -1){
                arr.splice(i, 1);
            }else{
                arr.push(index)
            }
            this.$set(this, 'openIndexs', arr);
        }
    }
}
</script>
<style lang="scss" scoped>
.enroll_info{
    padding: 40px;
    box-sizing: border-box;
    .enroll_title{
        font-size: 32px;
        color: #B9B9B9;
        line-height: 44px;
        font-weight: 500;
    }
    .enroll_time{
        display: flex;
        align-items: center;
        font-size: 28px;
        color: #1B1C1E;
        line-height: 48px;
        font-weight: 400;
        margin-top: 8px;
        img{
            width: 38px;
            height: 38px;
            margin-right: 10px;
        }
    }
    ul{
        margin-top: 32px;
        >li{
            width: 100%;
            height: auto;
            background: #FAFBFA;
            border-radius: 20px;
            margin-bottom: 16px;
            .info{
                display: flex;
                padding: 24px;
                box-sizing: border-box;
                position: relative;
                .num{
                    width: 120px;
                    height: 120px;
                    background: #FFFFFF;
                    border-radius: 20px;
                    text-align: center;
                    padding-top: 12px;
                    box-sizing: border-box;
                    box-shadow: 0 10px 19px 0 #F2F3F3;
                    p:nth-of-type(1){
                        font-size: 28px;
                        color: #B9B9B9;
                        font-weight: 400;
                        line-height: 40px;
                    }
                    p:nth-of-type(2){
                        font-size: 40px;
                        color: #00C2DC;
                        font-weight: 500;
                        line-height: 56px;
                    }
                }
                .enroll_detail{
                    width: calc(100% - 120px);
                    height: auto;
                    padding-left: 12px;
                    padding-top: 14px;
                    box-sizing: border-box;
                    .enroll_title{
                        font-size: 28px;
                        color: #1B1C1E;
                        font-weight: 500;
                        line-height: 40px;
                    }
                    .enroll_group{
                        width: 100%;
                        height: auto;
                        margin-top: 10px;
                        &.open{
                            p{
                                white-space: normal;
                            }
                        }
                        &.close{
                            p{
                                width: calc(100% - 66px);
                                white-space: nowrap;
                                @include ellipsis;
                            }
                        }
                        p{
                            width: 100%;
                            font-size: 28px;
                            color: #999999;
                            line-height: 44px;
                            font-weight: 400;
                        }
                    }
                }
                >img{
                    width: 48px;
                    height: 48px;
                    position: absolute;
                    top: 24px;
                    right: 20px;
                }
            }
            .group_detail{
                padding-top: 16px;
                .group_title{
                    min-height: 40px;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    &::after,
                    &::before{
                        content:'';
                        flex: 1;
                        border-bottom:1px #F0F0F0 solid;
                    }
                    span{
                        margin: 0 24px;
						font-family: PingFangSC-Regular;
                        font-size: 26px;
                        color: #666666;
                        letter-spacing: 0;
                        line-height: 40px;
                        font-weight: 400;
                        text-align: center;
                        word-break: break-all;
                        i{
                            font-family: PingFangSC-Medium;
                            color: #1B1C1E;
                            font-weight: 500;
                        }
                    }
                }
                ol{
                    padding: 24px 44px 40px;
                    box-sizing: border-box;
                    li{
                        min-height: 78px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin-bottom: 16px;
                        &:last-of-type{
                            margin-bottom: 0;
                        }
                        .member_info{
                            width: calc(100% - 100px);
                            p:nth-of-type(1){
                                font-size: 28px;
                                color: #1B1C1E;
                                font-weight: 400;
                                line-height: 40px;
                            }
                            p:nth-of-type(2){
                                font-size: 24px;
                                color: #999999;
                                font-weight: 400;
                                line-height: 34px;
                                margin-top: 4px;
                            }
                        }
                        .member_num{
                            width: 100px;
                            font-size: 28px;
                            color: #7AD21A;
                            font-weight: 500;
                            line-height: 40px;
                            text-align: right;
                        }
                    }
                }
            }
        }
    }
}
</style>